import Vue from 'vue'

Vue.directive('drag_ligature', {
  bind: function(el, binding) {
    let {self, type, isShow} = binding.value

    if(!isShow) {
      return ;
    }
    
    if (window.matchMedia("(max-width: 1080px)").matches) { // 可以根据需要设置不同的断点
      el.ontouchstart = (e) => {
        self.clickTouchDown(e, type)
      }
    } else {
      el.onmousedown = (e) => {
        self.clickMouseDown(e, type)
      }
    }
  }
})
